// extracted by mini-css-extract-plugin
export default {"card":"card_card__7WVYK","isClickable":"card_isClickable__RRIq4","img":"card_img__CZG1V","card-info":"card_card-info__oOp-I","card-actions":"card_card-actions__bBhJ3"};